/**import { createApp } from 'vue'
import App from './App.vue'

const app = createApp(App)
app.mount('#app')

console.log('FRONTE END Vue montata correttamente!')*/

/**import { createApp } from 'vue'
import App from './App.vue'

const app = createApp(App)
app.mount('#app')

console.log('BACK OFFICE Vue montata correttamente!')*/
import {
  createApp
} from 'vue'
import App from './App.vue'

import {
  createWebHistory,
  createRouter
} from 'vue-router'

// Import Bootstrap and its styles
//import * as bootstrap from 'bootstrap' 
//import 'bootstrap'
import 'bootstrap-italia/dist/css/bootstrap-italia.min.css';
import * as bootstrapItalia from 'bootstrap-italia/dist/js/bootstrap-italia.bundle.min.js'

//import 'bootstrap-italia/src/bootstrap-italia.scss';
//import 'bootstrap-italia/dist/js/bootstrap-italia.bundle.min.js';
import 'typeface-titillium-web'
import { createAuthService, createApi } from './services/api'
import QuestionsView from './components/views/questions/QuestionsView.vue'
import QuestionView from './components/views/questions/QuestionView.vue'
import QuestionDetailView from './components/views/questions/QuestionDetailView.vue'
import HomeView from './components/views/HomeView.vue'
import ArticleView from './components/views/ArticleView.vue'
import ArticlesView from './components/views/ArticlesView.vue'
import QuestionsByTopicsView from './components/views/questions/QuestionsByTopicsView.vue';
import ListaPareriConsultabili from './components/views/questions/ListaPareriConsultabili.vue';
console.log('Bootstrap Italia CSS:', document.styleSheets);

// Make bootstrap available globally
window.bootstrapItalia = bootstrapItalia;

const response = await fetch(`${import.meta.env.VITE_BASE_URL}config.json?v=${Date.now()}`);
const config = await response.json();
const api = createApi(config.VITE_APP_BACKOFFICE_URL)



/** configurazione router - inizio*/

const routes = [
  { path: '/questions/:id', name: 'questionsdetail', component: QuestionDetailView, props: true },
  { path: '/questions', name: 'questions.list', component: QuestionsView },
  { path: '/questions/new', name: 'questions.new', component: QuestionView },
  { path: '/article/:article/:version?', name: 'article', component: ArticleView, props: true },
  { path: '/index.html', component: ArticleView },
  { path: '/articles', component: ArticlesView },
  { path: '/questions/topic', name: 'questions.topic', component: QuestionsByTopicsView },
  { path: '/pareri', name: 'pareri.list', component: ListaPareriConsultabili },
]

const router = createRouter({
  history: createWebHistory(config.VUE_APP_BASE_PATH),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition);
        } else {
          resolve({
            top: 0,
            left: 0
          });
        }
      }, 100);
    });
  }
})

console.log('ROUTES CONFIGURATE:', router.getRoutes())

router.afterEach(() => {
  const meta = document.createElement("meta");
  meta.httpEquiv = "Cache-Control";
  meta.content = "no-cache, no-store, must-revalidate";
  document.head.appendChild(meta);
});

/** configurazione router - fine*/

const app = createApp(App)
app.config.globalProperties.$config = config
app.config.globalProperties.$api = api
console.log('API caricata:', app.config.globalProperties.$api)
//app.config.globalProperties.$authService = createAuthService(api)
app.use(router)
app.mount('#app')